import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const WeatherTableRow = ({ children }: Props) => {
  return <tr className="border-b-[1px] border-b-[#adb5bd]">{children}</tr>;
};
